import {Text, View } from 'react-native-web';


const Title = ({value, color1}) => {
  return (
    <View style={{alignSelf:'center', alignItems:'center', width:'90%', marginTop:15}}>
      <Text style={{fontSize:18, fontWeight:'bold', color: color1}}>{value}</Text>
    </View>);}

const SubTitle = ({value, color1}) => {
    return (
      <View style={{alignSelf:'center', alignItems:'center', width:'90%', marginTop:7.5}}>
        <Text style={{fontSize:16, fontWeight:'600', color: color1}}>{value}</Text>
      </View>);}

const Body = ({value, color1}) => {
    return (
      <View style={{alignSelf:'center', alignItems:'flex-start', width:'90%', marginTop:7.5}}>
        <Text style={{fontSize:14, fontWeight:'400', color: color1}}>{value}</Text>
      </View>);} 
      
const ButtonText = ({text, color}) => {
        return (
            <Text style={{fontSize:16, fontWeight:'bold', color: color}}>{text}</Text>);}   

const Date = ({value, color1}) => {
              return (
                <View style={{ alignSelf:'center', width:'90%', marginTop:15, alignItems:'center'}}>
                  <Text style={{fontSize:16, fontWeight:'bold', color: color1}}>{value}</Text>
                </View>);}

const Address = ({value, color1}) => {
  return (
    <View style={{alignSelf:'center', justifyContenent:'center', width:'90%', marginTop:15, alignItems :'center'}}>
      <Text style={{fontSize:16, fontWeight:'600', color: color1}}>{value}</Text>
    </View>);}

const ReplyText =({title, body})=>{
  return (
    <View style={{alignSelf:'flex-start' , width:'100%', height:'100%', padding:15}}>
     <Text style={{fontSize:16, fontWeight:'bold', color: '#F9BA49'}}>{title}{" "}</Text>
     <Text style={{fontSize:16, fontWeight:'400', color: '#F9BA49'}}>{body}</Text>
    </View>);}

const AbilityList =({list})=>{
  var ability=[...list]
  
  return(
  <View style={{alignSelf:'flex-start' , width:'100%', height:'100%', padding:15, marginBottom:15}}>
   {ability?.map((item, index)=>( <Text style={{fontSize:14, fontWeight:'bold', color: '#F9BA49'}} key={index}>{'-'}{index+1}{'-'}{' '}{item}</Text>))}
   </View>)
}

const AbilityTitle = ({value, color1}) => {
  return (
    <View style={{alignSelf:'center', alignItems:'center', width:'90%', marginTop:20}}>
      <Text style={{fontSize:14, fontWeight:'bold', color: color1}}>{value}</Text>
    </View>);}

const ButtonListText = ({text, color}) => {
  return (
      <Text style={{fontSize:14, fontWeight:'bold', color: color}}>{text}</Text>);}   

      const AbilityBody = ({value, color1}) => {
        return (
          
            <Text style={{fontSize:14, fontWeight:'400', color: color1}}>{value}</Text>);} 

            const SheeTitle = ({value, color1}) => {
              return (
                <View style={{alignSelf:'center', width:'90%'}}>
                  <Text style={{fontSize:16, fontWeight:'bold', color: color1}}>{value}</Text>
                </View>);}

function Corps (props){
  return (
   <Text style={{color:'#F9BA49', fontWeight:'400', fontSize:14, marginHorizontal:15, marginTop:props.margin}} onPress={props.onPress}>{props.value}</Text>
  )}

export {Title, SubTitle, Body, ButtonText, Date, Address, ReplyText, ButtonListText, AbilityList, AbilityTitle, AbilityBody, SheeTitle, Corps}
